import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as sastActionTypes from '../sastActionTypes';

/**
 * Update SAST overview data flow
 */
const updateSASTOverviewDataFlow = function* updateSASTOverviewDataFlow() {
    while (true) {
        const {payload} = yield take(sastActionTypes.SUBMIT_SAST_TRIP_DETAILS_FORM);
        const {serviceAssignmentLineNo, serviceCaseId, serviceAssignmentData} = payload;

        yield* updateServiceAssignment({
            caller: sastActionTypes.SUBMIT_SAST_TRIP_DETAILS_FORM,
            assignmentType: efServiceAssignmentTypes.SHORT_TRIP,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sastActionTypes.SUBMIT_SAST_TRIP_DETAILS_FORM},
        });
    }
};

export default updateSASTOverviewDataFlow;
